import serverContext from 'server-only-context';

/**
 * Server-only context for the v2 experiment pipeline flag.
 *
 * Set once per request in fetchPageData (after resolving the Statsig gate)
 * and read synchronously by ModuleCollectionRenderer to choose between
 * the v2 pipeline and the legacy Ninetailed-coupled path.
 */
export const [getUseV2Pipeline, setUseV2Pipeline] = serverContext<boolean>(false);
